
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL, userLoginApi } from '../../utils/Constants';

export const loginUser = createAsyncThunk(
  "loginUser",
  async (payload, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      };
      const response = await axios.post(
        `${BASE_URL}${userLoginApi}`,
        payload,
        config
      );
      localStorage.setItem("Token", response.data.data.accessToken);
      localStorage.setItem("userId", response.data.data._id);
      localStorage.setItem("type", response.data.data.type);
      return response.data;
    } catch (error) {
      localStorage.removeItem("Token");
      localStorage.removeItem("userId");
      localStorage.removeItem("type");
      return rejectWithValue(
        error?.response?.data?.message || "Failed to login."
      );
    }
  }
);

const loginSlice = createSlice({
  name: "login",
  initialState: {
    data: null,
    isAuthenticated: false,
    loading: false,
    error: null,
  },
  reducers: {
    clearData: (state) => {
      // Reset the data property to an empty array
      state.data = null;
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.token = action.payload.token;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export const { clearData } = loginSlice.actions;
export default loginSlice.reducer;
